import requestAction from '../utils/requestAction'

export const fetchSettlementRecords = (params: string) =>
  requestAction('SETTLEMENT_RECORD_LIST', params)(`settlementRecords`, 'GET')

